__turbopack_context__.v({
  "close": "Dialog-module__z0Wspa__close",
  "content": "Dialog-module__z0Wspa__content",
  "content-in": "Dialog-module__z0Wspa__content-in",
  "content-out": "Dialog-module__z0Wspa__content-out",
  "description": "Dialog-module__z0Wspa__description",
  "overlay": "Dialog-module__z0Wspa__overlay",
  "overlay-in": "Dialog-module__z0Wspa__overlay-in",
  "overlay-out": "Dialog-module__z0Wspa__overlay-out",
  "title": "Dialog-module__z0Wspa__title",
});
